import axios from 'axios'

import { setEndpointStatusOutside } from '../../../store/endpointStatus'
import { B2B_RULE_TYPES } from '../utils/constants'

export const IS_PROD = process.env.NODE_ENV === 'production'

let prodBackend = 'https://app.marketcalculus.ai:9090'
let acao = 'https://app.marketcalculus.ai'
if (window.location.host.startsWith('test.marketcalculus.ai')) {
  prodBackend = 'https://test.marketcalculus.ai:9091'
  acao = 'https://test.marketcalculus.ai:9091'
}
export const BASE_URL = IS_PROD ? prodBackend : 'http://127.0.0.1:9090'
export const HOMEPAGE_URL = 'https://marketcalculus.ai'

const createAxiosInstance = () => {
  const instance = axios.create({
    baseURL: BASE_URL + '/b2b/api/v1',
    withCredentials: true
  })

  instance.interceptors.request.use(config => {
    const lang = localStorage.getItem('lang') || 'en'

    // Don't override Content-Type if it's FormData (for file uploads)
    const headers = {
      ...config.headers,
      'Access-Control-Allow-Origin': acao,
      dil: lang
    }

    // Only set Content-Type to application/json if data is not FormData
    if (!(config.data instanceof FormData)) {
      headers['Content-type'] = 'application/json'
    }

    config.headers = headers
    return config
  })

  instance.interceptors.response.use(
    (response) => {
      return response
    },
    (err) => {
      if (B2B_RULE_TYPES.includes(err?.response?.data?.detail?.body?.detail?.ruleType)) {
        setEndpointStatusOutside('errorMessage', err.response.data.detail.body.detail)
      }
      return Promise.reject(err)
    }
  )

  return instance
}

const B2BAPI = createAxiosInstance()
export default B2BAPI
